import { ObjectFinder, Props } from "Components/ObjectFinder";

import { formatLicensePlate } from "Formatting/formatLicensePlate";
import React from "react";

export const LicensePlateObjectFinder = ({
  searchProps: { onChange, ...inputPropsRest },
  ...rest
}: Props): React.ReactElement => {
  return (
    <ObjectFinder
      {...rest}
      searchProps={{
        ...inputPropsRest,
        inputProps: { ...inputPropsRest.inputProps, maxLength: 9 },
        onChange: (e) => {
          e.target.value = formatLicensePlate(e.target.value);
          onChange && onChange(e);
        },
      }}
    />
  );
};
